module.exports = __webpack_public_path__ + "img/2.0ba8d943.jpg";